/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ListReportDefinitionQueryResponse, ListReportDefinitionQueryParams } from "../models/ListReportDefinition";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listReportDefinition } from "../axios/listReportDefinition";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listReportDefinitionQueryKey = (params: ListReportDefinitionQueryParams = {}) => ["audit-reports-api", { url: '/report-definitions' }, ...(params ? [params] : [])] as const

export type ListReportDefinitionQueryKey = ReturnType<typeof listReportDefinitionQueryKey>

export function listReportDefinitionQueryOptions(params?: ListReportDefinitionQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listReportDefinitionQueryKey(params)
        return queryOptions<ListReportDefinitionQueryResponse, ResponseErrorConfig<Error>, ListReportDefinitionQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listReportDefinition(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns all report definitions for the client, optionally filtered by report type
 * @summary List all report definitions
 * {@link /report-definitions}
 */
export function useListReportDefinition<TData = ListReportDefinitionQueryResponse, TQueryData = ListReportDefinitionQueryResponse, TQueryKey extends QueryKey = ListReportDefinitionQueryKey>(params?: ListReportDefinitionQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListReportDefinitionQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? listReportDefinitionQueryKey(params)
         

         const query = useQuery({
          ...listReportDefinitionQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}